import styled, { createGlobalStyle } from 'styled-components';
import {
  GRAPHITE_COLOR,
  ICE_COLOR,
  LG_COLOR,
  MAIN_BLUE_COLOR,
  PLATINUM_COLOR,
  SOFT_GREY_COLOR,
} from 'containers/App/constants';

export const PodManagementPageStyles = styled.div`
  background: ${ICE_COLOR};
  min-height: 100%;
  padding: 24px;

  .pod-management-shell {
    margin: 0 auto;
    max-width: 1400px;
  }

  .pod-management-header,
  .pod-management-filter-panel,
  .pod-management-panel,
  .pod-management-log-panel {
    background: #fff;
    border: 1px solid #dde2e8;
    border-radius: 8px;
    box-shadow: 0 8px 22px rgba(65, 70, 80, 0.08);
  }

  .pod-management-header {
    align-items: flex-start;
    display: flex;
    gap: 22px;
    justify-content: space-between;
    margin-bottom: 18px;
    padding: 22px 24px;
  }

  .pod-management-eyebrow {
    color: ${LG_COLOR};
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0;
    margin-bottom: 6px;
    text-transform: uppercase;
  }

  .pod-management-title {
    color: ${GRAPHITE_COLOR};
    font-size: 1.65rem;
    font-weight: 600;
    line-height: 1.25;
    margin: 0;
  }

  .pod-management-subtitle {
    color: #66707d;
    margin: 8px 0 0;
    max-width: 780px;
  }

  .pod-management-metrics {
    display: grid;
    gap: 14px;
    grid-template-columns: repeat(3, minmax(110px, 1fr));
    min-width: 400px;
  }

  .pod-management-metric {
    border-left: 1px solid ${PLATINUM_COLOR};
    padding-left: 18px;
  }

  .pod-management-metric-value {
    color: ${MAIN_BLUE_COLOR};
    font-size: 1.65rem;
    font-weight: 700;
    line-height: 1;
  }

  .pod-management-metric-label {
    color: ${GRAPHITE_COLOR};
    font-size: 0.8rem;
    font-weight: 600;
    margin-top: 8px;
  }

  .pod-management-filter-panel {
    margin-bottom: 18px;
    padding: 18px;
  }

  .pod-management-partial-alert {
    border-radius: 8px;
    margin-bottom: 18px;
  }

  .pod-management-label {
    color: ${GRAPHITE_COLOR};
    font-size: 0.84rem;
    font-weight: 600;
    margin-bottom: 8px;
    white-space: nowrap;
  }

  .pod-management-grid {
    display: grid;
    gap: 18px;
    grid-template-columns: minmax(0, 1fr) minmax(340px, 0.38fr);
  }

  .pod-management-panel,
  .pod-management-log-panel {
    overflow: hidden;
  }

  .pod-management-panel-header {
    align-items: center;
    background: ${SOFT_GREY_COLOR};
    border-bottom: 1px solid #d9dde3;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding: 14px 18px;
  }

  .pod-management-panel-title {
    color: ${GRAPHITE_COLOR};
    font-size: 1rem;
    font-weight: 700;
    margin: 0;
  }

  .pod-management-table-scroll {
    max-height: calc(100vh - 410px);
    min-height: 420px;
    overflow: auto;
  }

  .pod-management-table-scroll table {
    min-width: 780px;
  }

  .pod-management-table-scroll th {
    background: #f3f5f8;
    border-bottom: 1px solid #d9dde3;
    color: ${GRAPHITE_COLOR};
    font-size: 0.78rem;
    position: sticky;
    text-transform: uppercase;
    top: 0;
    z-index: 3;
  }

  .pod-management-name {
    color: ${GRAPHITE_COLOR};
    font-weight: 700;
    white-space: nowrap;
  }

  .pod-management-meta {
    color: #66707d;
    font-size: 0.82rem;
    margin-top: 4px;
    white-space: nowrap;
  }

  .pod-management-chip-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .pod-management-actions-heading {
    align-items: center;
    display: flex;
    gap: 4px;
    justify-content: flex-end;
    white-space: nowrap;
  }

  .pod-management-actions-column {
    min-width: 110px;
    white-space: nowrap;
  }

  .pod-management-info-button.btn-link {
    align-items: center;
    color: ${MAIN_BLUE_COLOR};
    display: inline-flex;
    font-size: 1rem;
    height: 24px;
    justify-content: center;
    padding: 0;
    text-decoration: none;
    width: 24px;
  }

  .pod-management-info-button.btn-link:hover,
  .pod-management-info-button.btn-link:focus {
    color: ${LG_COLOR};
    text-decoration: none;
  }

  .pod-management-tooltip-list {
    display: grid;
    gap: 5px;
    text-align: left;
  }

  .pod-management-primary-button.btn-primary {
    background-color: ${LG_COLOR};
    border-color: ${LG_COLOR};
  }

  .pod-management-primary-button.btn-primary:hover,
  .pod-management-primary-button.btn-primary:focus {
    background-color: #8d012d;
    border-color: #8d012d;
  }

  .pod-management-loading-state,
  .pod-management-empty-state {
    align-items: center;
    color: #66707d;
    display: flex;
    justify-content: center;
    min-height: 320px;
    padding: 24px;
    text-align: center;
  }

  .pod-management-log-body {
    max-height: calc(100vh - 410px);
    min-height: 420px;
    overflow: auto;
    padding: 14px;
  }

  .pod-management-log-item {
    border: 1px solid #e3e7ec;
    border-radius: 8px;
    margin-bottom: 10px;
    padding: 12px;
  }

  .pod-management-log-topline {
    align-items: center;
    display: flex;
    gap: 8px;
    justify-content: space-between;
  }

  .pod-management-log-action {
    color: ${GRAPHITE_COLOR};
    font-weight: 700;
    overflow-wrap: anywhere;
  }

  .pod-management-log-meta {
    color: #66707d;
    font-size: 0.8rem;
    margin-top: 6px;
    overflow-wrap: anywhere;
  }

  .pod-management-config-summary {
    background: #fff;
    border: 1px solid #e3e7ec;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 14px;
  }

  .pod-management-config-summary h4 {
    color: ${GRAPHITE_COLOR};
    font-size: 0.92rem;
    font-weight: 700;
    margin: 0 0 8px;
  }

  .pod-management-config-summary dl {
    display: grid;
    gap: 8px 14px;
    grid-template-columns: max-content minmax(0, 1fr);
    margin: 0;
  }

  .pod-management-config-summary dt {
    color: #66707d;
    font-weight: 600;
  }

  .pod-management-config-summary dd {
    color: ${GRAPHITE_COLOR};
    margin: 0;
    overflow-wrap: anywhere;
  }

  .pod-management-config-section {
    background: #f8f9fb;
    border: 1px solid #e3e7ec;
    border-radius: 8px;
    padding: 16px;
  }

  .pod-management-config-section-header {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
    margin-bottom: 14px;
  }

  .pod-management-config-section-header h5 {
    color: ${GRAPHITE_COLOR};
    font-size: 0.95rem;
    font-weight: 700;
    margin: 0;
  }

  .pod-management-config-section-header p {
    color: #66707d;
    font-size: 0.82rem;
    margin: 4px 0 0;
  }

  .pod-management-textarea {
    font-family:
      SFMono-Regular,
      Consolas,
      Liberation Mono,
      monospace;
    min-height: 112px;
    resize: vertical;
  }

  .pod-management-textarea-large {
    min-height: 132px;
  }

  .form-control:focus,
  .form-select:focus {
    border-color: ${MAIN_BLUE_COLOR};
    box-shadow: 0 0 0 0.18rem rgba(22, 81, 119, 0.16);
  }

  @media (max-width: 1199px) {
    .pod-management-grid {
      grid-template-columns: 1fr;
    }

    .pod-management-log-body,
    .pod-management-table-scroll {
      max-height: none;
    }
  }

  @media (max-width: 991px) {
    padding: 16px;

    .pod-management-header {
      flex-direction: column;
      padding: 18px;
    }

    .pod-management-metrics {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      min-width: 0;
      width: 100%;
    }

    .pod-management-metric {
      border-left: 0;
      border-top: 1px solid ${PLATINUM_COLOR};
      padding-left: 0;
      padding-top: 14px;
    }
  }

  @media (max-width: 575px) {
    padding: 12px;

    .pod-management-title {
      font-size: 1.35rem;
    }

    .pod-management-metrics {
      grid-template-columns: 1fr;
    }

  }
`;

export const PodManagementModalGlobalStyles = createGlobalStyle`
  .pod-management-tooltip-list {
    display: grid;
    gap: 5px;
    text-align: left;
  }

  .pod-management-actions-dialog .modal-content,
  .pod-management-config-dialog .modal-content {
    border: 1px solid #d9dde3;
    border-radius: 8px;
    box-shadow: 0 16px 36px rgba(41, 47, 56, 0.22);
  }

  .pod-management-actions-dialog .modal-header,
  .pod-management-config-dialog .modal-header {
    background: ${SOFT_GREY_COLOR};
    border-bottom: 1px solid #d9dde3;
    padding: 16px 18px;
  }

  .pod-management-actions-dialog .modal-title,
  .pod-management-config-dialog .modal-title {
    color: ${GRAPHITE_COLOR};
    font-size: 1rem;
    font-weight: 700;
  }

  .pod-management-actions-dialog .modal-body {
    padding: 18px 20px 20px;
  }

  .pod-management-modal-actions {
    display: grid;
    grid-template-columns: repeat(3, 84px);
    justify-content: space-between;
    margin: 0 auto;
    max-width: 300px;
    row-gap: 12px;
    width: 100%;
  }

  .pod-management-modal-action.btn-primary {
    align-items: center;
    background: ${LG_COLOR};
    border: 1px solid ${LG_COLOR};
    border-radius: 8px;
    color: #fff;
    display: inline-flex;
    flex-direction: column;
    font-size: 0.8rem;
    font-weight: 700;
    height: 68px;
    justify-content: center;
    padding: 10px 8px;
    white-space: nowrap;
    width: 84px;
  }

  .pod-management-modal-action.btn-primary svg {
    color: #fff;
    font-size: 1.1rem;
  }

  .pod-management-modal-action.btn-primary:hover:not(:disabled),
  .pod-management-modal-action.btn-primary:focus:not(:disabled) {
    background: #8d012d;
    border-color: #8d012d;
    box-shadow: 0 0 0 0.16rem rgba(165, 0, 52, 0.12);
  }

  .pod-management-modal-action.btn-primary:disabled {
    background: #e9edf2;
    border-color: #d7dde4;
    color: #8f98a3;
    opacity: 1;
  }

  .pod-management-modal-action.btn-primary:disabled svg {
    color: #a7b0ba;
  }

  .pod-management-disabled-action-wrapper {
    display: inline-flex;
    height: 68px;
    width: 84px;
  }

  .pod-management-disabled-action-wrapper .btn:disabled {
    pointer-events: none;
  }

  @media (max-width: 575px) {
    .pod-management-modal-actions {
      grid-template-columns: repeat(2, 84px);
      max-width: 200px;
    }
  }
`;
